import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getGDPR } from '@app/redux/clientLocale/selectors';
import { getCustomerGDPRStatus } from '@app/redux/customer/selectors';
import { useUserIsLoggedIn } from '@app/user';
import { useHistory, useLocation } from '@app/router';

const useRedirectToGDPRPage = () => {
  const isLoggedIn = useUserIsLoggedIn();
  const { pathname } = useLocation();
  const history = useHistory();
  const prevPath = pathname || '/';
  const isGDPR = useSelector(getGDPR);
  const gdprStatus = useSelector(getCustomerGDPRStatus);

  useEffect(() => {
    if (
      isGDPR &&
      isLoggedIn &&
      gdprStatus === 'DECLINED' &&
      !['/gdpr', '/login', '/signup, /signout'].includes(String(pathname))
    ) {
      history.push({ pathname: '/gdpr', state: { prevPath } });
    }
  }, [gdprStatus, history, isGDPR, isLoggedIn, pathname, prevPath]);
};

export default useRedirectToGDPRPage;
